import { 
	GET_PAINT_SURFACE_PREPS, 
	GET_PAINT_SURFACE_PREP,
	CREATE_PAINT_SURFACE_PREP,
	UPDATE_PAINT_SURFACE_PREP,
	DESTROY_PAINT_SURFACE_PREP,
} from "./actions"

export function PaintSurfacePrepsReducer(state = {}, action) {
	switch (action.type) {
		case `${GET_PAINT_SURFACE_PREPS}_FULFILLED`:{
			return _.mapKeys(action.payload.data, "id");
		}
		case `${GET_PAINT_SURFACE_PREP}_FULFILLED`:
		case `${CREATE_PAINT_SURFACE_PREP}_FULFILLED`:
		case `${UPDATE_PAINT_SURFACE_PREP}_FULFILLED`:{
			let newState = _.clone(state);
			const newItem = action.payload.data;
			const id = _.get(newItem,"id")
			newState[id] = newItem
			return newState;
		}		
		case `${DESTROY_PAINT_SURFACE_PREP}_FULFILLED`:{
			let newState = _.clone(state);
			const deletedItem = action.payload.data;
			const id = _.get(deletedItem,"id")
			newState = _.filter(newState,i => i.id != id)
			return newState;
		}
		default:
			return state;
	}
}

// Move this to the reducer page
// import { PaintSurfacePrepsReducer } from "modules/paint/surface_preps/reducer"

// paint_surface_preps:PaintSurfacePrepsReducer,
